import React, { forwardRef } from 'react';
import { mergeClassNames } from '../../../utils';
import styles from './index.module.scss';

export const size = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large',
  max: 'max',
  full: 'full',
};

export const spacing = {
  none: 'none',
  tight: 'tight',
  normal: 'normal',
  medium: 'medium',
  spacy: 'spacy',
};

export default forwardRef(
  /**
   * @param {object} props
   * @param {React.ReactNode} props.children
   * @param {string} [props.spacing='none']
   * @param {string} [props.id]
   * @param {object} [props.image]
   * @param {string} [props.className]
   * @param {string} [props.innerClassName]
   * @param {React.CSSProperties} [props.style]
   * @param {string} [props.size='large']
   * @param {keyof JSX.IntrinsicElements} [props.as='section']
   * @param {React.ForwardedRef<any>} [ref]
   * @returns JSX.Element
   */
  function Section(
    {
      children,
      className = '',
      size = 'large',
      spacing = 'none',
      id = undefined,
      image = undefined,
      style = undefined,
      innerClassName = '',
      as = 'section',
    },
    ref
  ) {
    /** @type {keyof JSX.IntrinsicElements} */
    const As = as;
    return (
      <As
        // @ts-ignore
        id={id}
        className={mergeClassNames(styles.section, className)}
        style={{ ...style, backgroundImage: image ? `url(${image})` : '' }}
        ref={ref}
      >
        <div className={mergeClassNames(styles.inner, styles[size], styles[spacing], innerClassName)}>{children}</div>
      </As>
    );
  }
);
